import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoxProps } from 'UIKit/Box/types'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import { RouteConfig } from 'config/constants/route'
import { useCountDown } from 'hooks/useCountdown'
import { useRouter } from 'hooks/useRouter'
import { useRef } from 'react'
import { Trans } from 'react-i18next'
import { useSystemData } from 'state/system/hooks'
import styled from 'styled-components'
import NotificationBarContainer from './NotificationBarContainer'

export const MaintenanceNoti: React.FC<BoxProps> = () => {
  const systemInfo = useSystemData()
  const router = useRouter()
  const alarmRef = useRef<HTMLDivElement | null>(null)

  const shudownTimeTextRef = useCountDown(
    systemInfo?.serviceShutdownAt,
    (s, m) => {
      if (s < 30 && m == 0) {
        alarmRef.current.className = `${alarmRef.current.className} alarm`
      }

      return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
    },
    () => {
      router.push(RouteConfig.Maintenance)
    },
  )

  return (
    <StyledContainer ref={alarmRef} width="100%">
      <Flex alignItems="center" width="100%" height="100%" justifyContent="center">
        <Box width={['24px', '', '34px']} height={['24px', '', '34px']}>
          <Image src="/images/maintenance-noti.png" alt="maintenence icon" width={32} height={32} />
        </Box>
        <StyledTextContainer>
          <Text
            display="contents"
            ml={['', '4px']}
            fontSize={['12px', '', '14px']}
            lineHeight={['16px', '16px', '24px']}
          >
            <Trans>HunnyPlay will be temporarily down for maintenance in </Trans>

            <Text
              display="contents"
              ref={shudownTimeTextRef}
              ml="4px"
              fontSize={['12px', '', '14px']}
              bold
              color="warning"
            >
              ...
            </Text>
          </Text>
        </StyledTextContainer>
      </Flex>
    </StyledContainer>
  )
}

const StyledContainer = styled(NotificationBarContainer)`
  &.alarm {
    animation: alarm 1s infinite;
  }

  @keyframes alarm {
    0% {
      background-color: ${({ theme }) => theme.colors.error}55;
    }

    100% {
      background-color: transparent;
    }
  }
`

const StyledTextContainer = styled(Flex)`
  padding: 4px 0px;
  height: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
`

export default MaintenanceNoti
